<template>
  <div class="auth-page d-flex justify-content-center align-items-center">
    <mdb-container>
      <mdb-card style="width: 100%;">
        <mdb-card-header color="dark ">Sign up to virallyze</mdb-card-header>
        <mdb-card-body class="w-100">
          <div class="d-flex justify-content-center mt-5" v-if="isLoading">
            <div class="spinner-grow text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-if="!isLoading">
            <div v-if="showAlert" class="col-12">
              <mdb-alert class="d-flex justify-content-center" color="danger">
                <b>Oh no,</b>
                {{ alertText }}
              </mdb-alert>
            </div>

            <form v-if="!accountCreated" autocomplete="off">
              <div class="grey-text">
                <mdb-input
                  label="Your first name"
                  icon="user"
                  type="text"
                  v-model="firstName"
                />
                <mdb-input
                  label="Your last name"
                  icon="user"
                  type="text"
                  v-model="lastName"
                />
                <mdb-input
                  label="Your email"
                  icon="envelope"
                  type="email"
                  v-model="email"
                />
                <mdb-input
                  label="Your password"
                  autocomplete="off"
                  icon="lock"
                  type="password"
                  v-model="password"
                />
                <mdb-input
                  label="Confirm your password"
                  icon="exclamation-triangle"
                  type="password"
                  v-model="passwordConfirm"
                />
              </div>
              <div class="text-center">
                <mdb-btn
                  color="indigo"
                  :disabled="signUpDisabled"
                  @click="register"
                  >Register</mdb-btn
                >
              </div>
            </form>

            <div v-if="accountCreated">
              <h3>Account created!</h3>
              <p>
                Thank you for your registation {{ firstName }}. Please check
                your inbox to verify your e-mail adress
              </p>
            </div>
          </div>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbBtn,
  mdbAlert,
} from "mdbvue";

export default {
  name: "Register",
  components: {
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbAlert,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      passwordConfirm: "",
      accountCreated: false,
      showAlert: false,
      alertText: "",
    };
  },
  computed: {
    signUpDisabled: function() {
      return (
        this.firstName === "" ||
        this.lastName === "" ||
        this.email === "" ||
        this.password === "" ||
        this.passwordConfirm === ""
      );
    },
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    },
  },
  methods: {
    register: function() {
      if (this.password !== this.passwordConfirm) {
        this.showAlert = true;
        this.alertText = " please check your password.";
        return;
      }

      let data = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        password: this.password,
      };
      let currentContext = this;
      this.$store.commit("ui/is_loading", true);
      this.$store
        .dispatch("user/register", data)
        .then(() => {
          currentContext.accountCreated = true;
          currentContext.showAlert = false;
          this.$store.commit("ui/is_loading", false);
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.showAlert = true;
            this.alertText = " it looks like the mail is already taken.";
            this.$store.commit("ui/is_loading", false);
          }
        });
    },
  },
  mounted: function() {
    this.showAlert = false;
  },
};
</script>
